export default "__VITE_ASSET__cBHtdBYu__"